import { render } from "./discuss_stock.vue?vue&type=template&id=6a34ff7e"
import script from "./discuss_stock.vue?vue&type=script&lang=js"
export * from "./discuss_stock.vue?vue&type=script&lang=js"

import exportComponent from "D:\\shiv_mfg_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__